import { Reveal, Overline } from "./Reveal";

const STEPS = [
    { n: "01", title: "Upload", body: "Upload a photo or provide your preferences." },
    { n: "02", title: "Analyze", body: "LookAura uses AI to analyze your appearance and style." },
    { n: "03", title: "Personalize", body: "The recommendation engine combines the analysis with your preferences." },
    { n: "04", title: "Discover", body: "Explore personalized looks, products, and recommendations." },
];

export default function HowItWorks() {
    return (
        <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 sm:py-32 bg-[#0A0A0A] border-y border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <Reveal>
                    <Overline>The Method</Overline>
                    <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                        How it <span className="italic text-amber-500">works</span>
                    </h2>
                    <div className="hairline mt-10" />
                </Reveal>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.12}>
                            <div data-testid={`step-${s.n}`} className="group relative">
                                <span className="font-serif-display font-light text-7xl sm:text-8xl text-white/10 group-hover:text-amber-500/30 transition-colors duration-500 leading-none">
                                    {s.n}
                                </span>
                                <h3 className="mt-4 font-serif-display text-2xl tracking-tight text-[#FAFAFA]">{s.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.body}</p>
                                {i < STEPS.length - 1 && (
                                    <span className="hidden lg:block absolute top-10 -right-4 w-8 h-px bg-amber-600/40" aria-hidden="true" />
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
